import ScrollToTop from "react-scroll-to-top";

export function ScrollTop() {
  return (
    <>
      <ScrollToTop smooth style={{ backgroundColor: "#ff6347" }} />
    </>
  );
}
